<div class="uploading-process">
  <label>{{process}}</label>
  <mat-spinner diameter="35" strokeWidth="2"></mat-spinner>
  <label>Este proceso puede tardar unos minutos, mientras puedes seguir usando Hire&Sign</label>
</div>
